import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=daf27af6"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=daf27af6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\oywen\\niehao\\qft\\20260317\\vue-admin-template-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daf27af6')) {
      api.createRecord('daf27af6', component.options)
    } else {
      api.reload('daf27af6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=daf27af6", function () {
      api.rerender('daf27af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/channelList/detail.vue"
export default component.exports